<template lang="html">
<div>
      <div class="subpage ent_edit">
            <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
                <div class="text-block title-block clearfix">
                    <div class="bName">企业全称</div>
                    <div class="bContent">
                        <el-form-item style="width:100%;" prop="companyName">
                           <el-input class="inpText" size="medium" v-model="params.companyName" placeholder="请输入企业全称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="selects">
                      <div class="select-line">

                          <div class="selectGp">
                                <span>主体类型</span>
                                <el-form-item prop="subjectTypeId">
                                    <dic-select code="ztlx"
                                         :selectId="params.subjectTypeId"
                                         paramsKey="subjectType"
                                         @selectChange="selectChange"
                                         plaText="主体类型" />
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span>所在行业</span>
                                <el-form-item prop="industryId">
                                    <dic-select code="szhy"
                                         :selectId="params.industryId"
                                         paramsKey="industry"
                                         @selectChange="selectChange"
                                         plaText="所在行业" />
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span>人员规模</span>
                                <el-form-item prop="staffSizeId">
                                    <dic-select code="rygm" :selectId="params.staffSizeId" paramsKey="staffSize" plaText="人员规模" @selectChange="selectChange" />
                                </el-form-item>
                          </div>

                      </div>

                      <div class="select-line">

                        <div class="selectGp">
                              <span>产业放向</span>
                              <el-form-item prop="industryDirectionId">
                                  <dic-select code="cyfx"
                                       :selectId="params.industryDirectionId"
                                       paramsKey="industryDirection"
                                       @selectChange="selectChange"
                                       plaText="产业放向" />
                              </el-form-item>
                        </div>

                        <div class="selectGp">
                              <span class="cName">创建者</span>
                              <el-form-item prop="industryDirectionId">
                                  <el-select
                                    v-model="mebId"
                                    filterable
                                    remote
                                    placeholder="请输入关键词"
                                    size="medium"
                                    @change="adminChange"
                                    :remote-method="goSeek"
                                    :loading="loading">
                                    <el-option
                                      v-for="item in mebList"
                                      :key="item.id"
                                      :label="item.realName"
                                      :value="item.id">
                                        <div>
                                              {{item.cellPhone | transPhone}}
                                              <span style="color:#999999;margin-left:3px;">{{item.realName}}</span>
                                        </div>
                                    </el-option>
                                  </el-select>
                              </el-form-item>

                        </div>

                      </div>

                      <div class="select-line">

                          <div class="selectGp">
                                <span class="cName">分组</span>
                                <el-form-item prop="groupsId">
                                    <dic-select code="qyfz"
                                         :selectId="params.groupsId"
                                         paramsKey="groups"
                                         @selectChange="selectChange" />
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span>信息发布</span>
                                <el-form-item prop="informationReleaseIds">
                                    <all-select code="sxfb"
                                         :selectId="params.informationReleaseIds"
                                         paramsKey="informationReleaseIds"
                                         @selectChange="allSelect" />
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span>身份类别</span>
                                <el-form-item prop="identityTypeId">
                                    <all-select code="sflx"
                                         :selectId="params.identityTypeId"
                                         paramsKey="identityTypeId"
                                         @selectChange="allSelect" />
                                </el-form-item>
                          </div>
                         </td>
                      </div>

                </div>
            </el-form>

      </div>
</div>
</template>

<script>
import { decPredat } from "@/api/declare/declare";
import { dicSeek } from "@/api/pgMent/dictMent";
import { userSeek } from "@/api/account";

export default {
  props: ['entid'],
  filters: {
    transPhone: function (e) {
      return e.substr(0, 3) + '****' + e.substr(8, 11);
    }
  },
  data() {
    return {
      mebId: '',
      mebList: [],
      identityArr: [],
      params: {
        status: '',
        companyName: '',
        subjectType: '',  // 主体类型
        subjectTypeId: '',
        industry: '',  // 所在行业
        industryId: '',
        staffSize: '',  // 人员规模
        staffSizeId: '',
        industryDirection: '',  // 产业方向
        industryDirectionId: '',
        founder: '',
        founderId: '',
        creatorMobilePhoneNumber: '',
        groups: '',  // 分组
        groupsId: '',
        informationReleaseIds: '',
        identityTypeId: '',
        identityType: ''
      },
      rules: {
        companyName: [{
          required: true,
          trigger: 'blur'
        }],
        subjectTypeId: [{
          required: true,
          trigger: 'blur'
        }],
        industryId: [{
          required: true,
          trigger: 'blur'
        }],
        staffSizeId: [{
          required: true,
          trigger: 'blur'
        }],
        industryDirectionId: [{
          required: true,
          trigger: 'blur'
        }],
        // groupsId:[{
        //    required: true,
        //    trigger: 'blur'
        // }],
        // informationReleaseIds:[{
        //    required: true,
        //    trigger: 'blur'
        // }],
      }
    }
  },
  methods: {
    // 创建者
    adminChange: function (e) {
      this.mebList.forEach(item => {
        if (item.id == e) {
          this.params.founder = item.realName;
          this.params.founderId = e;
          this.params.creatorMobilePhoneNumber = item.cellPhone;
        }
      })
    },
    // 主体类型
    selectChange: function (e) {
      this.params[e.paramsKey] = e.name;
      this.params[e.paramsKey + 'Id'] = e.id;
    },
    // 信息发布
    allSelect: function (e) {
      this.params[e.paramsKey] = e.id;
      if (e.paramsKey == 'identityTypeId') {
        this.params.identityType = e.name;
      }
    },
    // 创建者
    goSeek: function (e) {
      var vues = this;
      userSeek({ where: e, no: 1, size: 20 }).then(res => {
        vues.mebList = [];
        res.userListByWhereList.forEach((item, i) => {
          if (item.cellPhone) {
            vues.mebList.push(item);
          }
        });
      })
    },
    preEdit: function (e) {
      this.params = e.enterprise;
      this.mebId = this.params.founderId;
      this.goSeek(this.params.founder);
    },
    saveReturn: function () {
      var vues = this;
      return new Promise((reslove, reject) => {
        vues.$refs.ruleForm.validate((valid) => {
          if (valid) {
            reslove(vues.params);
          } else {
            reslove(false);
          }
        })
      })
    }
  },
  created: function () {
    var querys = this.$route.query;
    var vues = this;

    dicSeek({ code: 'sflx' }).then(res => {
      this.selectList1 = res.dataDictionarys;
    })

  }
}
</script>

<style lang="scss" scoped>
.selects {
  .select-line {
    position: relative;
    margin-bottom: 30px;
    margin-top: 30px;
    .selectGp {
      display: inline-block;
      width: 32%;
      span {
        font-size: 15px;
        margin-right: 12px;
      }

      .cName {
        display: inline-block;
        width: 60px;
      }
    }
  }
}

.text-block {
  font-size: 15px;
  margin-bottom: 20px;
  .bName {
    width: 60px;
    float: left;
    margin-top: 9px;
  }
  .bContent {
    margin-left: 76px;
    position: relative;
  }
}

.title-block {
  width: 32%;
  margin-top: 12px;
}

.img-block {
  margin-top: 30px;
}

.radio-block {
  margin-top: 60px;
}

.tag-block {
  margin-top: 45px;
  .bName {
    margin-top: 6px;
  }
}

.check-block {
  margin-top: 30px;
  .check-seek {
    .seek-head {
      position: relative;
      .el-icon-search {
        position: absolute;
        left: 15px;
        top: 12px;
        color: #dcdfe6;
        z-index: 2;
      }
      .el-select {
        width: 432px;
      }
    }
    .seek-body {
      .el-tag {
        margin-right: 12px;
        margin-top: 12px;
      }
    }
  }
}

.enclosure {
  margin-top: 60px;
  .ttl {
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent {
    margin-left: 75px;
  }
}
</style>

<style lang="css">
.subpage.ent_edit .el-input__inner {
  border-radius: 0px !important;
}

.subpage.ent_edit .selects .el-input {
  width: 240px !important;
}

.subpage.ent_edit .el-form-item {
  display: inline-block !important;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// Subpage1.vue?58e43dde